module.exports = __webpack_public_path__ + "static/media/top-img_4.a31e7f79.png";